import {environment} from '@environment';
import {tap} from 'rxjs';
import type {MonoTypeOperatorFunction} from 'rxjs';
import type {ZodType} from 'zod';

type NonNullableProps<T> = {
  [P in keyof T]: NonNullable<T[P]>;
};

export function parseResponse<T>(schema: ZodType): MonoTypeOperatorFunction<T> {
  return tap({
    next: (value: T) => {
      if (!environment.production) {
        // Throw in development so we're aware of the error
        schema.parse(value);
      } else {
        const parsed = schema.safeParse(value);
        if (parsed.success === false) {
          // Log to service to be informed
          console.log(parsed.error);
        }
      }
    },
  });
}

export function isNotNullish<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}

export function toNonNullableObject<T>(obj: T): NonNullableProps<T> {
  const result: any = {};
  for (const key in obj) {
    if (obj[key] !== null && obj[key] !== undefined) {
      result[key] = obj[key];
    }
  }
  return result;
}
